module.exports = __webpack_public_path__ + "img/hazardousIndustryInspection.abad3332.svg";